import {useQuery} from "react-query";
import {PccService} from "../../services/PccService";
import {buildResponseErrorMessage} from "../../services/api/errorHelpers";

export const useDocumentUploadCategoriesQuery = ({
  facilityId,
  enabled,
}: {
  facilityId: string;
  enabled: boolean;
}) =>
  useQuery(
    ["useDocumentUploadCategoriesQuery", facilityId],
    async ({queryKey: [_, facilityId]}) => {
      const {data} = await PccService.getDocumentUploadCategories(facilityId);
      return data;
    },
    {
      // Note: when the enabled is undefined, the query will run!
      enabled: Boolean(enabled),
      onError: async resp => {
        await buildResponseErrorMessage(
          resp,
          "Failed to fetch PointClickCare document categories. Please, try again later.",
        );
      },
    },
  );
